export const shuffleFunction = (array) => {
  const randomOrder = [...array].sort(() => Math.random() - 0.5);
  return randomOrder;
};
